// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610190538/js/" + chunkId + "." + {"44":"43cc6867","225":"eacc8bac","481":"7eadc4fc","486":"d13ffc57","770":"e5a9a4e6"}[chunkId] + ".0.6520811439135862.chunk.js";
};